import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector,
} from '@angular/core'

@Injectable()
export class ComponentBuilderService {
  constructor(
    private cfr: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  createInstance(elem: any, attachView = true): ComponentRef<any> {
    const cmpFactory = this.cfr.resolveComponentFactory(elem)
    const component = cmpFactory.create(this.injector)
    if (attachView) {
      this.appRef.attachView(component.hostView)
    }
    return component
  }
}
